import React from 'react';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';

const styles= {
  link: {
    display: 'initial'
  }
}

class PrivacyPolicyLink extends React.PureComponent {
  render() {
    const { classes } = this.props;

    return (
      <Typography variant='caption'>
        <Typography variant='caption' component={Link} to='/aviso-legal' className={classes.link}>Condiciones de uso</Typography> 
        &nbsp;&amp;&nbsp; 
        <Typography variant='caption' component={Link} to='/politica-privacitad' className={classes.link}>Política de Privacidad</Typography>
      </Typography>
    )
  }
}

export default withStyles(styles)(PrivacyPolicyLink);


// WEBPACK FOOTER //
// ./src/modules/shared/components/PrivacyPolicyLink.js